import { useContext, useState } from "react";

import EditInvoiceListingHeader from "./EditInvoiceListingHeader";

import EditInvoiceTable from "./EditInvoiceTable";
import BaseLoader from "../../../components/ui/BaseLoader";
import { LayoutContext } from "../../../context/LayoutContext";
import { useParams, useSearchParams } from "react-router-dom";
import {
  fetchEngineerInvoiceDetails,
  fetchInvoiceDetails,
  updateInvoiceStatus,
} from "../../../services/api/invoice";
import { useMutation, useQuery } from "@tanstack/react-query";
import { UserType } from "../../../utils/enum";

const EditInvoice = () => {
  const [searchParams] = useSearchParams();
  const role = searchParams.get("role");
  const { isBannerVisible } = useContext(LayoutContext);
  const { id: invoiceId } = useParams();
  const {
    isPending: isFetchInvoiceDetailsApiLoading,
    data: invoiceData,
    refetch: refetchInvoiceDetails,
  } = useQuery({
    queryKey: ["invoiceWorkOrders", invoiceId],
    queryFn:
      role === UserType.CLIENT
        ? () => fetchInvoiceDetails(invoiceId)
        : () => fetchEngineerInvoiceDetails(invoiceId),
    enabled: !!invoiceId,
  });

  return (
    <>
      <BaseLoader isLoading={isFetchInvoiceDetailsApiLoading} />
      <div
        className={`bg-[#F6F6F6] sm:fixed sticky 2xl:w-[95.2%] xl:w-[93.2%] lg:w-[90.6%] md:w-[87.5%] sm:w-[95%] w-full h-screen transition-all pt-4 ${
          isBannerVisible ? "top-[104px] sm:mt-0 mt-12" : "top-[42px]"
        }`}
      >
        <EditInvoiceListingHeader invoice={invoiceData?.data} />
        <EditInvoiceTable
          invoice={invoiceData?.data}
          refetchInvoiceDetails={refetchInvoiceDetails}
        />
      </div>
    </>
  );
};

export default EditInvoice;
